"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ExpandIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-866.000000, -237.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(864.000000, 235.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(11.500000, 11.500000) rotate(-135.000000) translate(-11.500000, -11.500000) translate(7.500000, 0.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              transform: "translate(4.000000, 11.500000) rotate(-180.000000) translate(-4.000000, -11.500000) translate(-0.000000, -0.000000)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(-0.000000, -0.000000)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  transform: "translate(4.000000, 11.500000) rotate(180.000000) translate(-4.000000, -11.500000) translate(-0.000000, -0.000000)",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(-0.000000, 0.000000)",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      transform: "translate(4.000000, 11.500000) rotate(-180.000000) translate(-4.000000, -11.500000) translate(0.000000, -0.000000)",
                      fill: color,
                      fillRule: "nonzero",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M3.1,19.4662122 L3.1,13.7279221 C3.1,13.2308658 3.50294373,12.8279221 4,12.8279221 C4.45882118,12.8279221 4.83745178,13.1712587 4.89298772,13.615028 L4.9,13.7279221 L4.9,19.4688887 L6.35192152,17.961366 C6.66807761,17.6332677 7.17317272,17.5970518 7.53085344,17.8589532 L7.62449512,17.9377769 C7.95259343,18.253933 7.98880929,18.7590281 7.72690787,19.1167088 L7.64808419,19.2103505 L4.62038281,22.3524179 C4.28946951,22.6958308 3.75497881,22.7175793 3.39815946,22.4211593 L3.31287674,22.3404279 L0.34057812,19.1404279 C0.00230246255,18.7762376 0.0233103703,18.2067765 0.387500595,17.8685009 C0.721341635,17.5584149 1.22766724,17.5502268 1.57029489,17.8315347 L1.65942759,17.9154234 L3.1,19.4662122 Z M4.9,3.2617103 L4.9,9 C4.9,9.49705627 4.49705627,9.9 4,9.9 C3.54117882,9.9 3.16254822,9.55666333 3.10701228,9.11289409 L3.1,9 L3.1,3.25903985 L1.64808133,4.76655961 C1.33192524,5.09465793 0.82683013,5.13087379 0.469149415,4.86897237 L0.375507738,4.79014869 C0.0474094209,4.4739926 0.0111935634,3.96889748 0.273094984,3.61121677 L0.351918666,3.51757509 L3.37962004,0.375507738 C3.71053334,0.0320947868 4.24502404,0.010346331 4.60184339,0.30676627 L4.68712611,0.38749774 L7.65942474,3.58749774 C7.99770039,3.95168796 7.97669248,4.52114908 7.61250226,4.85942474 C7.27866122,5.16951075 6.77233562,5.17769878 6.42970796,4.89639087 L6.34057526,4.81250226 L4.9,3.2617103 Z"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      transform: "translate(4.000000, 5.272078) rotate(-180.000000) translate(-4.000000, -5.272078) translate(1.000000, 1.272078)"
                    })]
                  })
                })
              })
            })
          })
        })
      })
    })
  })]
});

ExpandIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ExpandIcon;
exports.default = _default;